import * as tslib_1 from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { DeviceType, AppModule } from '@/store/modules/app';
import { AppMain, Navbar, Sidebar, RouteTabs } from './components';
import Resize from './mixin/resize';
let default_1 = class extends mixins(Resize) {
    get status() {
        return {
            hideSidebar: !this.sidebar.opened,
            openSidebar: this.sidebar.opened,
            withoutAnimation: this.sidebar.withoutAnimation,
            mobile: this.device === DeviceType.Mobile,
        };
    }
    mounted() { }
    handleClickOutside() {
        AppModule.CloseSideBar(false);
    }
};
default_1 = tslib_1.__decorate([
    Component({
        name: 'Layout',
        components: {
            AppMain,
            Navbar,
            Sidebar,
            RouteTabs,
        },
    })
], default_1);
export default default_1;
